import React from 'react';
import {VideoEditorState} from '../store/VideoEditorStore';
import styles from './ChunkListOverlay.module.css';
import {ReactComponent as RegenerateIcon} from '../../../assets/images/regenerate-icon.svg';
import {ReactComponent as MuteAudioIcon} from '../../../assets/images/mute-icon.svg';
import {VideoEditorText} from '../VideoEditorText';

interface Props {
  state: VideoEditorState;
  isLoading: boolean;
  refreshChunks: () => void;
}

const ChunkListOverlay: React.FC<Props> = ({
  state,
  isLoading,
  refreshChunks,
}: Props) => {
  const getLoadingText = (state: VideoEditorState) => {
    return state === VideoEditorState.Regenerating
      ? VideoEditorText.stateRegenerating
      : state === VideoEditorState.MutingAudio
      ? VideoEditorText.stateMutingAudio
      : '';
  };

  return (
    <div>
      {isLoading && <div className={styles.overlay}></div>}
      {(state === VideoEditorState.Regenerating ||
        state === VideoEditorState.MutingAudio) && (
        <div className={styles.overlay}>
          <span className={styles.loadingText} onClick={refreshChunks}>
            {state === VideoEditorState.Regenerating && <RegenerateIcon />}
            {state === VideoEditorState.MutingAudio && <MuteAudioIcon />}
            {getLoadingText(state)}
          </span>
        </div>
      )}
    </div>
  );
};
export default ChunkListOverlay;
